import script from "./JobDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./JobDetails.vue?vue&type=script&setup=true&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./JobDetails.vue?vue&type=style&index=1&id=049a9702&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/employer/employer/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-049a9702"]])

export default __exports__